import HelpTooltip from "components/general/HelpTooltip";
import { Button, HStack, Pressable, Text } from "components/ui";
import CheckBox from "expo-checkbox";
import React from "react";
import { Platform } from "react-native";
import { UserGroup } from "store/abcoApi";

const UserGroupCheckboxField = ({
	field,
	label,
	value,
	userGroup,
	onChange,
	helpText,
}: {
	helpText: string;
	value?: boolean | null;
	field: keyof UserGroup;
	label: string;
	userGroup: UserGroup;
	onChange: (value: boolean, field: keyof UserGroup) => void;
}) => {
	function handleChange(newValue: boolean | null) {
		if (newValue !== null && newValue !== undefined) {
			// Ensures you don't send null values
			setChecked(newValue);
			onChange(newValue, field);
		}
	}
	const [checked, setChecked] = React.useState(value);

	return (
		<HStack gap={4} my={12} alignItems="center">
			{Platform.OS === "web" ? (
				<Button gap={6} padding={0} onPress={() => handleChange(!checked)}>
					<CheckBox color={"#2B6FBB"} value={checked} />
					<Text fontSize={14}>{label}</Text>
					{helpText && <HelpTooltip tip={helpText} />}
				</Button>
			) : (
				<Pressable onPress={() => handleChange(!checked)} flexDirection="row" gap={8}>
					<CheckBox color={"#2B6FBB"} value={checked} />
					<Text fontSize={14}>{label}</Text>
					{helpText && <HelpTooltip tip={helpText} />}
				</Pressable>
			)}
		</HStack>
	);
};

export default UserGroupCheckboxField;
